export const DecorCircles = () => {
  return (
    <div className="flex justify-center items-center mx-auto p-10">
      <p className="after:content-[''] after:text-red-500 block text-sm font-medium text-slate-700 border-4 border-pink-500 rounded-full p-2"></p>
      <p className="after:content-[''] border-4 border-pink-500 rounded-full p-4"></p>
      <p className="after:content-['']  border-4 border-pink-500 rounded-full p-4"></p>
      <p className="after:content-['']  border-4 border-pink-500 rounded-full p-2"></p>
    </div>
  );
};
